<template>
  <el-form class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 xl:tw-flex tw-gap-x-6 tw-gap-y-3 tw-items-start">
    <i-form-item
      v-if="$isInRole(['ADMIN', 'CONSULTANT', 'AGENCY'])"
    >
      <MultiSelectWithSearch
        v-model="filters.client_company"
        option-object-label-key="name"
        :options="clientsCompanies"
        :label="$t('foreigners.filters.client_company')"
        :handle-change="(payload) => updateFilter('client_company', payload)"
      />
    </i-form-item>
    <i-form-item
      v-if="$isInRole(['ADMIN', 'CONSULTANT'])"
    >
      <MultiSelectWithSearch
        v-model="filters.assigned_to"
        option-object-label-key="fullname"
        :options="internalUserOptions"
        :label="$t('foreigners.filters.assigned_to')"
        :handle-change="(payload) => updateFilter('assigned_to', payload)"
      />
    </i-form-item>
    <i-form-item>
      <MultiSelectWithSearch
        v-model="filters.status"
        option-object-label-key="name"
        :options="userStatuses"
        :label="$t('foreigners.permits.current_status')"
        :handle-change="(payload) => updateFilter('status', payload)"
      />
    </i-form-item>
    <i-form-item>
      <MultiSelectWithSearch
        v-model="filters.permit_status"
        option-object-label-key="name"
        :options="permitStatuses"
        :label="$t('foreigners.filters.main_status')"
        :handle-change="(payload) => updateFilter('permit_status', payload)"
      />
    </i-form-item>
    <i-form-item :label="$t('foreigners.filters.permit_obtained')">
      <el-select
        :model-value="filters.permit_obtained"
        placeholder=""
        filterable
        clearable
        @change="(payload) => updateFilter('permit_obtained', payload)"
      >
        <el-option
          v-for="permit in [
            {
              name: $t('foreigners.filters.obtained'),
              id: 10,
            },
            {
              name: $t('foreigners.filters.not_obtained'),
              id: 20,
            },
          ]"
          :key="permit.id"
          :label="permit.name"
          :value="permit.id"
        />
      </el-select>
    </i-form-item>
    <div class="tw-flex tw-gap-2">
      <el-tooltip
        :content="$t('foreigners.filters.include_family')"
      >
        <i-button
          size="large"
          :is-active="Boolean(filters.include_family)"
          is-icon
          @click="updateFilter('include_family', filters.include_family === 1 ? 0 : 1)"
        >
          <icon-users />
        </i-button>
      </el-tooltip>

      <el-tooltip
        v-if="$isInRole(['ADMIN', 'AGENCY']) || ($isInRole(['HR']) && me.features.case_assessments)"
        :content="$t('foreigners.filters.case_assessment')"
      >
        <i-button
          size="large"
          :is-active="Boolean(filters.case_assessment)"
          is-icon
          @click="updateFilter('case_assessment', filters.case_assessment === 1 ? 0 : 1)"
        >
          <icon-user-arrow-left />
        </i-button>
      </el-tooltip>
      <i-button
        v-if="someFilterSelected"
        is-icon
        size="large"
        @click="resetFilters"
      >
        <icon-close />
      </i-button>
    </div>
  </el-form>
</template>

<script>
import MultiSelectWithSearch from '@/components/shared/MultiSelectWithSearch.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  components: { MultiSelectWithSearch },
  computed: {
    ...mapState({
      me: (state) => state.v2.shared.profile.me,
      filters: (state) => state.v2.admin.foreigners.foreigners.filters,
      userStatuses: (state) => state.v2.shared.enums.enums.user_statuses,
    }),
    ...mapGetters({
      someFilterSelected: 'v2/admin/foreigners/foreigners/someFilterIsSelected',
      clientsCompanies: 'v2/admin/cms/clients/companies/selectOptions',
      internalUserOptions: 'v2/admin/cms/internal/users/selectOptions',
      permitStatuses: 'v2/admin/cms/permitManagement/statuses/selectOptions',
    }),
  },
  methods: {
    updateFilter(field, payload) {
      this.$store.commit('v2/admin/foreigners/foreigners/updateFilter', { field, payload });
    },
    resetFilters() {
      this.$store.commit('v2/admin/foreigners/foreigners/resetFilters');
    },
  },
};
</script>
